import {SubscriptionType} from "./enums/SubscriptionType";

export const plans = [
    {
        key: SubscriptionType.FREE,
        name: 'Free',
        priceLabel: '$0 / month',
        highlights: ['Great for getting started'],
    },
    {
        key: SubscriptionType.PREMIUM,
        name: 'Premium',
        priceLabel: '$9.99 / month',
        highlights: ['Unlimited everything', 'AI + file uploads'],
    },
];